import { styled } from "@linaria/react"
import { Link } from "@tanstack/react-router"
import { useMemo } from "react"

import { Avatar } from "@/components/Avatar/Avatar.tsx"
import { Horizontal } from "@/components/Flex.ts"
import { Tooltip } from "@/components/Tooltip/Tooltip.tsx"
import { getFullName, useMyProfile, useProfile } from "@/hooks/useProfile.ts"
import { toProfileUsername } from "@/lib/std.ts"
import { Navigator } from "@/routes/Navigator.ts"
import { useCurrentOrgId } from "@/routes/projects/projectHooks.ts"

export const ProfileMention = (props: {
  url: string
}) => {
  const myProfile = useMyProfile()

  const username = useMemo(() => {
    return props.url.substring(props.url.lastIndexOf("/") + 1)
  }, [props.url])

  const profile = useProfile(toProfileUsername(username))

  const orgId = useCurrentOrgId()

  if (profile.error || !profile.data) {
    return <Unresolved>@{username}</Unresolved>
  }

  return (
    <Tooltip content={
      profile.data && (
        <Horizontal alignItems="center" gap="8px">
          <Avatar profile={profile.data} size={24} />
          <ProfileLink {...Navigator.user(orgId, profile.data.username)} viewTransition>
            {getFullName(profile.data)}
          </ProfileLink>
        </Horizontal>
      )
    }>
      <Username isMe={username === myProfile?.username}>{`@${username}`}</Username>
    </Tooltip>
  )
}

const Username = styled.span<{ isMe?: boolean }>`
  color: ${props => props.isMe ? "var(--warning-color)" : "var(--badge-teal)"};
  background-color: ${props => props.isMe ? "var(--warning-color-10)" : "var(--badge-teal-10)"};

  padding: 0 2px;
  border-radius: var(--border-radius-2);
`

const ProfileLink = styled(Link)`
  color: inherit;
`

const Unresolved = styled.span`
  font-weight: 600;
`